var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuteOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.03125C18.4335 9.08895 19 10.4783 19 12C19 13.5217 18.4335 14.911 17.5 15.9687M19.7083 6C21.1334 7.59227 22 9.69494 22 12C22 14.3051 21.1334 16.4077 19.7083 18M4 7.90417H2.33333C1.59695 7.90417 1 8.47454 1 9.17813V14.8219C1 15.5255 1.59695 16.0959 2.33333 16.0959H4M4 7.90417V16.0959M4 7.90417L8.71964 3.14627C10.0223 2.10907 12 2.99413 12 4.6143V19.3857C12 21.0059 10.0223 21.891 8.71963 20.8538L4 16.0959M12 8.17813V15.8219C14.2091 15.8219 16 14.1108 16 12C16 9.88925 14.2091 8.17813 12 8.17813Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteOff);
export default __webpack_public_path__ + "static/media/mute_off.bdd3c92f08bfe8d9620b6a24f41aa95b.svg";
export { ForwardRef as ReactComponent };